/**
 * Assets concern_bank_groups — used only to lay out P1 chips like the static topics page.
 * Saved answers remain canonical leaf need ids from the live P1 options.
 */

const GROUP_DEFS = {
  ADULT_INDIVIDUAL: [
    {label: 'اضطراب و ترس', ids: ['A_GAD', 'A_PANIC', 'A_SOCIAL_ANXIETY', 'A_SPECIFIC_PHOBIA', 'A_HEALTH_ANXIETY']},
    {label: 'خلق', ids: ['B_DEPRESSION', 'B_MOOD_CONCERN']},
    {label: 'سوگ و تروما', ids: ['B_GRIEF_LOSS', 'C_PTSD']},
    {label: 'وسواس/فکرها و رفتارهای تکراری', ids: ['A_OCD', 'A_BFRB']},
    {label: 'توجه و تمرکز', ids: ['SP_ADHD', 'SP_NEURODEVELOPMENTAL']},
    {label: 'عادت‌های اعتیادی', ids: ['I_SUBSTANCE_USE', 'I_GAMBLING', 'I_BEHAVIORAL_ADDICTION', 'I_COMPULSIVE_SEXUAL_BEHAVIOR']},
    {label: 'احساسات و واکنش‌های احساسی', ids: ['F_EMOTION_DYSREGULATION', 'F_NSSI', 'F_CHRONIC_ANGER', 'F_CHRONIC_SHAME_EMPTINESS', 'G_IMPULSE_CONTROL']},
    {label: 'رابطه، خودشناسی و هویت', ids: ['D1_INTERPERSONAL_PATTERNS', 'D1_LONELINESS_INTERPERSONAL', 'D1_PERFECTIONISM_SELF_CRITICISM', 'D1_SELF_ESTEEM', 'D2_MIGRATION_ACCULTURATION_IDENTITY', 'D2_IDENTITY_DEVELOPMENT', 'D2_SEXUAL_GENDER_IDENTITY_AFFIRMING', 'D2_MEANING_SPIRITUALITY']},
    {label: 'کار، تحصیل و مراحل زندگی', ids: ['D3_WORK_BURNOUT', 'D3_FINANCIAL_STRESS', 'D3_LIFE_DIRECTION_DECISION', 'D3_MAJOR_LIFE_TRANSITION', 'D3_CAREGIVER_BURDEN', 'D3_AGEING_RETIREMENT']},
    {label: 'بدن، خواب و سلامت', ids: ['SP_SLEEP', 'SP_EATING', 'SP_SEXUAL_HEALTH', 'SP_PERINATAL', 'SP_HEALTH_PAIN_SLEEP', 'SP_PSYCHOSIS']},
  ],
  ADULT_COUPLE: [
    {label: 'ارتباط و تعارض', ids: ['REL_COUPLE_CONFLICT', 'REL_ROLE_CONFLICT']},
    {label: 'اعتماد و آینده رابطه', ids: ['REL_INFIDELITY', 'REL_SEPARATION_DECISION', 'REL_REBUILDING']},
    {label: 'صمیمیت و شروع زندگی مشترک', ids: ['REL_COUPLE_SEXUAL_CONCERNS', 'REL_PREMARITAL']},
  ],
  CHILD_INDIVIDUAL: [
    {label: 'حال، ترس و تجربه‌های سخت', ids: ['A_GAD', 'A_SPECIFIC_PHOBIA', 'A_OCD', 'B_DEPRESSION', 'B_GRIEF_LOSS', 'C_DEVELOPMENTAL_TRAUMA']},
    {label: 'هیجان و رفتار', ids: ['F_EMOTION_DYSREGULATION', 'G_OPPOSITIONAL_BEHAVIOR', 'G_AGGRESSION_CONDUCT']},
    {label: 'توجه، رشد، مدرسه و همسالان', ids: ['SP_ADHD', 'SP_NEURODEVELOPMENTAL', 'PC_SCHOOL_REFUSAL', 'G_SCHOOL_FUNCTION_BEHAVIOR', 'D2_IDENTITY_DEVELOPMENT', 'I_SUBSTANCE_USE']},
    {label: 'خواب، غذا و بدن', ids: ['SP_SLEEP', 'SP_EATING']},
  ],
  PARENT_CONSULT_CHILD: [
    {label: 'رابطه و فرزندپروری', ids: ['SYS_PARENT_CHILD_CONFLICT', 'SYS_PARENTING_SUPPORT', 'SYS_POST_DIVORCE_RESTRUCTURING', 'SYS_ADOLESCENT_IN_FAMILY']},
    {label: 'حال، رفتار و رشد فرزند', ids: ['A_GAD', 'B_DEPRESSION', 'G_OPPOSITIONAL_BEHAVIOR', 'SP_ADHD', 'SP_NEURODEVELOPMENTAL', 'I_SUBSTANCE_USE']},
    {label: 'مدرسه', ids: ['PC_SCHOOL_REFUSAL']},
  ],
  FAMILY_WITH_CHILD: [
    {label: 'ارتباط و رابطه والد-فرزند', ids: ['SYS_FAMILY_COMMUNICATION', 'SYS_PARENT_CHILD_CONFLICT', 'SYS_ADOLESCENT_IN_FAMILY']},
    {label: 'بحران و بازسازی خانواده', ids: ['SYS_FAMILY_CRISIS', 'SYS_POST_DIVORCE_RESTRUCTURING']},
    {label: 'بیماری، سوگ و مراقبت', ids: ['SYS_FAMILY_COPING_ILLNESS', 'D3_CAREGIVER_BURDEN']},
  ],
  ADULT_FAMILY: [
    {label: 'ارتباط و بحران خانواده', ids: ['SYS_FAMILY_COMMUNICATION', 'SYS_FAMILY_CRISIS', 'SYS_POST_DIVORCE_RESTRUCTURING']},
    {label: 'سوگ، بیماری و مراقبت', ids: ['SYS_FAMILY_COPING_ILLNESS', 'D3_CAREGIVER_BURDEN']},
  ],
}

const TRACK_ORDER = [
  'ADULT_INDIVIDUAL',
  'ADULT_COUPLE',
  'CHILD_INDIVIDUAL',
  'PARENT_CONSULT_CHILD',
  'FAMILY_WITH_CHILD',
  'ADULT_FAMILY',
]

/** Map session service_track_id → GROUP_DEFS key (inherits use parent layout). */
const TRACK_GROUP_ALIAS = {
  ADULT_INDIVIDUAL: 'ADULT_INDIVIDUAL',
  OLDER_ADULT_INDIVIDUAL: 'ADULT_INDIVIDUAL',
  ADOLESCENT_INDIVIDUAL: 'CHILD_INDIVIDUAL',
  CHILD_INDIVIDUAL: 'CHILD_INDIVIDUAL',
  ADULT_COUPLE: 'ADULT_COUPLE',
  PARENT_CONSULT_CHILD: 'PARENT_CONSULT_CHILD',
  PARENT_CONSULT_ADOLESCENT: 'PARENT_CONSULT_CHILD',
  FAMILY_WITH_CHILD: 'FAMILY_WITH_CHILD',
  FAMILY_WITH_ADOLESCENT: 'FAMILY_WITH_CHILD',
  ADULT_FAMILY: 'ADULT_FAMILY',
}

export const P1_MAX_TOPICS = 6

/**
 * Lay out P1 chips using session service_track_id when known; else best-score heuristic.
 * @param {Array<{id:string,label?:string}>} options
 * @param {string|null} [serviceTrackId]
 * @returns {{groups: Array<{id:string,label:string,chips:Array}>, unsureOption: object|null, track: string}}
 */
export function groupConcernOptions(options, serviceTrackId) {
  const list = Array.isArray(options) ? options.filter((o) => o && o.id) : []
  const byId = {}
  list.forEach((o) => {
    byId[o.id] = o
  })
  const unsureOption = byId.UNSURE || null
  const needIds = list.map((o) => o.id).filter((id) => id !== 'UNSURE')

  let bestTrack = TRACK_GROUP_ALIAS[serviceTrackId] || null
  if (!bestTrack || !GROUP_DEFS[bestTrack]) {
    bestTrack = 'ADULT_INDIVIDUAL'
    let bestScore = -1
    TRACK_ORDER.forEach((track) => {
      const defs = GROUP_DEFS[track] || []
      let score = 0
      defs.forEach((g) => {
        g.ids.forEach((id) => {
          if (byId[id] && id !== 'UNSURE') {
            score += 1
          }
        })
      })
      if (score > bestScore) {
        bestScore = score
        bestTrack = track
      }
    })
  }

  const used = {}
  const groups = []
  ;(GROUP_DEFS[bestTrack] || []).forEach((g, index) => {
    const chips = []
    g.ids.forEach((id) => {
      if (byId[id] && id !== 'UNSURE' && !used[id]) {
        chips.push(byId[id])
        used[id] = true
      }
    })
    if (chips.length) {
      groups.push({
        id: bestTrack + '-' + index,
        label: g.label,
        chips,
      })
    }
  })

  const leftover = needIds.filter((id) => !used[id]).map((id) => byId[id])
  if (leftover.length) {
    groups.push({
      id: 'other',
      label: 'دیگر',
      chips: leftover,
    })
  }

  return {groups, unsureOption, track: bestTrack}
}
